import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @description Custom hook to delete all dummy student accounts
 */
export const useDeleteDummyStudent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Delete all dummy student accounts
   * @async
   */
  const deleteDummyStudent = async () => {
    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/student/dummy/destroy`;

      const response = await axiosInstance.delete(url);

      return response?.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    deleteDummyStudent,
  };
};
